"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUCCESS_NETWORK_RECONNECTED = exports.ERROR_NETWORK_DISCONNECTED = exports.ERROR_TAG_LENGTH = void 0;
var Types_1 = require("@CommonFrontendBackend/Project/Types");
exports.ERROR_TAG_LENGTH = "Whoops! Tags can't be longer than ".concat(Types_1.MAX_TAG_LENGTH, " characters");
exports.ERROR_NETWORK_DISCONNECTED = "Connection is unstable. Stay in your browser until all updates are saved.";
exports.SUCCESS_NETWORK_RECONNECTED = "Reconnected! You can continue editing.";
